import { render } from "./SideTimeLineItem.vue?vue&type=template&id=6d284554"
import script from "./SideTimeLineItem.vue?vue&type=script&lang=js"
export * from "./SideTimeLineItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__